/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'backbone',
        'underscore',
        'assets/js/modules/browser',
        'assets/js/common/router/index',
        'assets/js/modules/screen',
        'assets/js/modules/widgets/gallery/model/templateModel',
        'assets/js/modules/api/template',
        'assets/js/modules/pages/start/view/startPageView',
        'assets/js/modules/widgets/gallery/model/galleryModel',
        'assets/js/modules/widgets/gallery/view/templateView',
        'assets/js/modules/pages/start/view/productTabsView',
        'assets/js/modules/themes/OvernightPrints/modules/widgets/uploadInfo/uploadInfoWidgetView',
        'assets/js/modules/themes/OvernightPrints/modules/pages/start/view/pricingDeliveryView',
        'assets/js/modules/widgets/elements/image/imageView',
        'assets/js/modules/widgets/elements/image/imageModel',
        'assets/js/slider',
        'jquery-ui-touch-punch',
        'assets/js/start/regionWidgetSwitch'
    ],
    function(
        $,
        backbone,
        _,
        browser,
        router,
        screen,
        TemplateModel,
        templateApi,
        StartPageView,
        GalleryModel,
        TemplateView,
        ProductTabsView,
        OnpUploadInfoWidgetView,
        OnpPricingDeliveryView,
        ProductPreviewView,
        ProductPreviewModel
    ) {
        var TOTAL_TEMPLATES = 24;
        const HEADER_HEIGHT = 80;

        return StartPageView.extend({
            initialize: function(options) {
                StartPageView.prototype.initialize.call(this, arguments);
                this.galleryBlockSize = options.galleryBlockSize;
                var _this = this;
                var productSizeSelectElementSelector = '#product-size-select .region-tab select';
                this.$gallery = this.$('.gallery-content');
                this.templatesInitialized = false;
                this.pricingDeliveryInitialized = false;
                this.navAnimation = false;
                this.sideNavVisible = false;
                this.$sideNav = $('.page-navigation.fixed');
                this.productViewModel = new ProductPreviewModel();
                this.productView = new ProductPreviewView({
                    model: this.productViewModel,
                    el: '.product-preview-container'
                });

                $('.page-navigation a.link').on('click', function() {
                    var anchor = $(this).data('menuanchor');
                    _this.scrollToSection(anchor);
                });

                $('.page-navigation a.back-to-top').on('click', function() {
                    _this.scrollToSection(null);
                });

                // do that instantly, in case page was scrolled before reload
                _this.loadSections();
                $(window).on('scroll touchmove', function() {
                    _this.loadSections();
                });

                var $uploadSize = this.$('#upload-size');
                var $startFileSize = this.$('#start-file-size');
                var $pricingCalcProduct = this.$(productSizeSelectElementSelector);

                $('.dynamic-gallery-link').on('click', function(e) {
                    e.preventDefault();
                    _this.model.get('eventAgent').trigger('goToGalleryPage');
                });

                this.listenTo(this.model.get('eventAgent'), {
                    'product:changed': function(productSlug) {
                        _this.loadTemplates(productSlug, true);

                        if ($startFileSize.val() !== productSlug) {
                            $startFileSize.val(productSlug);
                            $startFileSize.trigger('change');
                        }

                        if (_this.$gallery.length > 0) {
                            _this.$gallery.sliderAction.reset();
                        }

                        _this.updateProductPreviewModel();
                    },
                    'StartPage:setProducts': _this.updateProductPreviewModel
                });

                $startFileSize.on('change', function() {
                    var productSlug = $(this).val();
                    $uploadSize.val(productSlug);
                    $uploadSize.trigger('change');

                    if ($pricingCalcProduct.length === 0) {
                        $pricingCalcProduct = _this.$(productSizeSelectElementSelector);
                    }
                    if ($pricingCalcProduct.length > 0 && _this._getPricingCalcProductVal($pricingCalcProduct) !== productSlug) {
                        _this._setPricingCalcProductVal($pricingCalcProduct, productSlug);
                        $pricingCalcProduct.selectBoxIt('refresh');

                        _this.model.trigger('product:beforeChange', productSlug);
                    }

                    _this.loadTemplates(productSlug, true);
                });

                var sectionHash = window.location.hash.substring(1);
                if (sectionHash) {
                    $(window).load(function() {
                        _this.scrollToSection(sectionHash);
                    });
                }
            },

            updateProductPreviewModel: function() {
                var defaultImage = null;
                var product = this.model.get('product');

                if (product) {
                    defaultImage = product.get('defaultImage') || null;
                }

                this.productViewModel.set({
                    src: defaultImage
                });
            },

            loadSections: function() {
                var $designsSection = $('.section-designs');
                var $pricingSection = $('.section-specs');
                var $bannerNavigation = $('.main-banner-section .page-navigation');

                if ($designsSection.length && screen.isElementVisible($designsSection)) {
                    this.initTemplates();
                }
                if (screen.isElementVisible($pricingSection)) {
                    this.initPricing();
                }
                if ($bannerNavigation.offset().top <= $(window).scrollTop()) {
                    this.showFixedMenu();
                } else {
                    this.hideFixedMenu();
                }
            },

            initPricing: function() {
                if (this.pricingDeliveryInitialized === true) {
                    return;
                }

                var $spinner = $('<i class="icon-spinner icon-spin icon-3x"></i>');
                var $tabsContent = $('#prod-info-container');
                $tabsContent.append($spinner);
                var $tabs = $tabsContent.find('.tab-pane');
                $tabs.addClass('tabs-loading');
                this.listenTo(this.model.get('eventAgent'), {
                    'StartPage:setProducts': function() {
                        $spinner.remove();
                        $tabs.removeClass('tabs-loading');

                        if (!$('#pricing-delivery-tab').hasClass('active')) {
                            $('#upload-tab').addClass('active');
                        }
                    }
                });

                this.pricingDeliveryInitialized = true;
                this.model.trigger('pricing:init');
            },

            initTemplates: function() {
                if (this.templatesInitialized === true) {
                    return;
                }
                this.templatesInitialized = true;

                this.loadTemplates(this.model.get('defaultProduct'), false);
            },

            loadTemplates: function(productSlug, updateSlider) {
                var _this = this;

                var $spinner = $('<i class="icon-spinner icon-spin icon-3x"></i>');
                var $galleryContent = $('.gallery-content');
                if (!$galleryContent.length) {
                    return;
                }
                $galleryContent.empty();
                $galleryContent.append($spinner);
                this.getTemplates(productSlug)
                    .done(function(collection) {
                        $galleryContent.empty();
                        if (collection.length > 0) {
                            _this.renderTemplates(collection);
                            if (updateSlider) {
                                _this.$gallery.sliderAction.update();
                            } else {
                                _this.initSlider();
                            }
                        } else {
                            $galleryContent.append(
                                '<div class="no-templates">' +
                                    $galleryContent.data('message-no-templates') +
                                    '<br>' +
                                    $galleryContent.data('message-no-templates-try-another') +
                                    '</div>'
                            );
                            $('.browse-templates').hide();
                        }
                    })
                    .fail(function() {
                        $galleryContent.empty();
                        $galleryContent.append(
                            '<div class="no-templates">' +
                                $galleryContent.data('message-no-templates') +
                                '<br>' +
                                $galleryContent.data('message-no-templates-try-another') +
                                '</div>'
                        );
                        $('.browse-templates').hide();
                    });
            },

            showFixedMenu: function() {
                var _this = this;
                if (_this.navAnimation === true || _this.sideNavVisible === true || _this.$sideNav.length < 1) {
                    return;
                }
                _this.navAnimation = true;
                var leftValue = screen.isLg() ? '10px' : '20px';

                this.$sideNav.show().animate({ left: leftValue }, function() {
                    _this.navAnimation = false;
                    _this.sideNavVisible = true;
                });
            },

            hideFixedMenu: function() {
                var _this = this;
                if (_this.navAnimation === true || _this.sideNavVisible === false || _this.$sideNav.length < 1) {
                    return;
                }
                _this.navAnimation = true;
                var leftValue = screen.isLg() ? '-120px' : '-90px';

                this.$sideNav.animate({ left: leftValue }, function() {
                    _this.navAnimation = false;
                    _this.sideNavVisible = false;
                    $(this).hide();
                });
            },

            /**
             * @param {string} productSlug
             * @return {$.Deferred}
             */
            getTemplates: function(productSlug) {
                var deferred = $.Deferred();

                this.getTemplatesCollection(productSlug).fetch({
                    success: function(collection) {
                        deferred.resolve(collection);
                    },
                    error: function() {
                        deferred.reject();
                    },
                    data: {
                        slug: productSlug,
                        limit: TOTAL_TEMPLATES
                    }
                });

                return deferred;
            },

            /**
             * @param {TemplateModel[]|backbone.Collection} collection
             */
            renderTemplates: function(collection) {
                var templatesArr = [];
                var _this = this;

                collection.models.forEach(function(item, i, arr) {
                    var templateView = new TemplateView({
                        model: item,
                        renderLinks: true,
                        designGallery: _this.model.get('productGroup').get('gallery')
                    });
                    templatesArr.push(templateView.render().$el.html());
                });

                this.$gallery.html(this.createGroupedBlocks(templatesArr).join(''));
            },

            /**
             * Returns array of grouped templates
             *
             * @param {string[]} templatesArr
             * @return {string[]}
             */
            createGroupedBlocks: function(templatesArr) {
                var groupedBlocks = [];

                var total = templatesArr.length < TOTAL_TEMPLATES ? templatesArr.length : TOTAL_TEMPLATES;
                for (var i = 0; i < total; i += this.galleryBlockSize) {
                    groupedBlocks.push(
                        '<div class="gallery-block">' + templatesArr.slice(i, i + this.galleryBlockSize).join('') + '</div>'
                    );
                }

                return groupedBlocks;
            },

            /**
             * @param {string} productSlug
             * @return {backbone.Collection}
             */
            getTemplatesCollection: function(productSlug) {
                var TemplatesCollection = backbone.Collection.extend({
                    model: TemplateModel,
                    url: router.generate(templateApi.API_GET_PRODUCT_TEMPLATES, {
                        slug: productSlug
                    }),
                    parse: function(data) {
                        return data._embedded.items;
                    }
                });

                return new TemplatesCollection();
            },

            /**
             * @return {undefined}
             */
            initSlider: function() {
                this.$gallery.sliderAction({
                    listParent: '.gallery',
                    listClass: '.gallery-block',
                    next: '.designs .next',
                    prev: '.designs .prev'
                });
            },

            /**
             * @return {undefined}
             */
            initProductTabsView: function() {
                new ProductTabsView({
                    model: this.model,
                    el: this.$el,
                    tabsContainer: '.prod-tabs',
                    tabsContent: '.tab-content',
                    initPricingOnTabChange: false
                });
            },

            /**
             * @override
             * @return {UploadInfoWidgetView}
             */
            createUploadInfoWidgetView: function() {
                return new OnpUploadInfoWidgetView({
                    el: '#upload-info-preview',
                    model: this.model.get('product'),
                    collection: this.model.get('products')
                });
            },

            initPricingDeliveryView: function() {
                new OnpPricingDeliveryView({
                    model: this.model,
                    el: this.$('.pricing')
                });
            },

            /**
             * @param {string} anchorName
             */
            scrollToSection: function(anchorName) {
                var offset = browser.isMobile() ? HEADER_HEIGHT : 0;
                var anchorOffset = $('div[data-anchor="' + anchorName + '"]').offset();
                var scrollOffset = anchorOffset ? anchorOffset.top - offset : 0;

                $('html, body').animate(
                    {
                        scrollTop: scrollOffset
                    },
                    scrollOffset === 0 ? 300 : 1000
                );
            },

            /**
             * @param {jQuery} $pricingCalcProduct
             * @return {string}
             * @private
             */
            _getPricingCalcProductVal: function($pricingCalcProduct) {
                if ($pricingCalcProduct.is('select')) {
                    return $pricingCalcProduct.val();
                }

                return $pricingCalcProduct.find('input:checked').val();
            },

            /**
             * @param {jQuery} $pricingCalcProduct
             * @param {string} value
             * @return {undefined}
             * @private
             */
            _setPricingCalcProductVal: function($pricingCalcProduct, value) {
                if ($pricingCalcProduct.is('select')) {
                    $pricingCalcProduct.val(value);

                    return;
                }

                $pricingCalcProduct
                    .find('input')
                    .prop('checked', false)
                    .filter('input[value="' + value + '"]')
                    .prop('checked', true);
            }
        });
    }
);
